import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GiphyViewer from './giphy-viewer.js';
export { DEFAULTS } from './constants.js';
import { GIPHY_TYPE } from './types.js';
import 'wix-rich-content-common';
import 'wix-rich-content-common/dist/statics/schemas/plugin-giphy.schema.json';
import 'lodash';
import './giphy-viewer-e3f57a06.js';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class GiphyComponent extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleReady", () => {
      if (!this.state.isLoaded) {
        this.setState({ isLoaded: true });
      }
    });
    __publicField(this, "renderPlayer", () => {
      const { componentData, theme, settings, isMobile, setComponentUrl } = this.props;
      return /* @__PURE__ */ React.createElement(
        GiphyViewer,
        {
          ref: this.setPlayer,
          componentData,
          theme,
          settings,
          isMobile,
          setComponentUrl
        }
      );
    });
    __publicField(this, "onKeyDown", (e, handler) => {
      if (e.key === "Enter" || e.key === " ") {
        handler();
      }
    });
    this.state = {
      isLoading: false,
      isLoaded: false
    };
  }
  render() {
    const { onClick } = this.props;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": "giphyPlayer", onClick, onKeyDown: (e) => this.onKeyDown(e, onClick) }, this.renderPlayer());
  }
}
__publicField(GiphyComponent, "type", {
  GIPHY_TYPE
});
GiphyComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func
};

export { GiphyComponent as Component };
//# sourceMappingURL=giphy-component.js.map
